import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100%;
  overflow: hidden;
`;

export const ContentColumn = styled.div`
  display: grid;
  grid-template-rows: 1fr min-content;
  overflow: hidden;
  
  border-right: 1px solid #3d3d3d;

  h3 {
    margin-top: 1rem;
  }

  h4 {
    padding: 1rem 0;
  }

  ul {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    height: fit-content;
    max-height: 100%;
    margin-bottom: 1rem;
    padding-bottom: 1rem;
    overflow-y: scroll;

    font-family: Inter, sans-serif;

    li {
      border-bottom: 1px solid #3d3d3d;

      padding-bottom: 1.4rem;

      &:last-child {
        border-bottom: 0px;
      }
    }
  }
`;

export const Body = styled.div`
  padding: 1.5rem;
  height: 100%;
  overflow: auto;
`;

export const Footer = styled.div`
  border-top: 1px solid #3d3d3d;
  padding: 1.5rem;

  > button {
    width: 100%;
  }
`;

export const FoundCoordContainer = styled.div`
  font-family: Inter, sans-serif;
  margin-bottom: 1.1rem;
  padding-bottom: 0.8rem;
`;

export const FoundCard = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;
  background-color: var(--black-300);
  padding: 0.7rem;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s;

  &:hover {
    background-color: var(--black-400);
  }

  button {
    background-color: transparent;

    svg {
      width: 26px;
      height: 26px;
    }
  }
`;

export const ListCoordItemHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ListCoordItemBody = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  justify-content: flex-start;
  margin-top: 0.6rem;

  button {
    margin-right: 0.5rem;
    font-family: Inter, sans-serif;
    color: var(--white);
    background-color: var(--black-400);
    padding: 0.3rem 0.5rem;
    border-radius: 6px;
    width: 33%;
    height: 2.3rem;
    transition: opacity 0.3s;
    font-weight: 600;
    font-size: 0.85rem;

    &:hover {
      opacity: 0.7;
    }

    &:disabled {
      cursor: not-allowed;
      background: #f2f2f3;
      opacity: 0.3;
      color: #000;
    }

    &.highlighted {
      background-color: var(--primary);
      color: var(--black-100);
    }

    &:last-of-type {
      margin-right: 0rem;
    }
  }
`;

export const MapColumn = styled.div`
  .map-container {
    width: 100%;
    height: 100%;
    position: relative;
  }
`;

export const CaptionWrapper = styled.div`
  bottom: 0;
  position: absolute;
  z-index: 999;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  margin: 1rem 0px;
`;

export const CaptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background-color: var(--black-100);
`;

export const CaptionBody = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-right: 1px solid #3d3d3d;
  padding: 0.7rem;
  font-family: Inter, sans-serif;
  font-size: 0.8rem;

  &:last-of-type {
    border: 0;
  }
`;

type CaptionIconProps = {
  variant: "active" | "inactive";
};

const captionIconVariants = {
  active: css`
    background-color: #39a428;
  `,
  inactive: css`
    background-color: #ffb800;
  `,
};

export const CaptionIcon = styled.div<CaptionIconProps>`
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 6px;
  margin-right: 0.8rem;
  ${({ variant }) => captionIconVariants[variant]}
`;

export const SaveButton = styled.button``;
